import { Typography } from '@freighthub/silhouette-core'
import { CSSProperties, PureComponent } from 'react'
import { I18N } from 'utils/localisation'

interface UpdateTableProps {
  content: string[][]
  style?: CSSProperties
}
type TStylesNames = 'container' | 'key' | 'value'
const styles: Record<TStylesNames, CSSProperties> = {
  container: {
    tableLayout: 'fixed',
    width: '100%',
  },
  key: {
    verticalAlign: 'top',
  },
  value: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}

export class UpdateTable extends PureComponent<UpdateTableProps> {
  render() {
    const { content } = this.props
    return (
      <table style={{ ...styles.container, ...this.props.style }}>
        <tbody>
          {content.map((keyValuePair) => (
            <tr key={keyValuePair[0]}>
              <td style={styles.key}>
                <Typography variant="body2" color="textSecondary">
                  <I18N term={keyValuePair[0]} />:
                </Typography>
              </td>
              <td style={styles.value}>
                <Typography variant="body2" color="textSecondary">
                  <I18N term={keyValuePair[1]} />
                </Typography>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}
